// extracted by mini-css-extract-plugin
module.exports = {"form":"form_form__1BeIw","select":"form_select__27ZBE","container":"form_container__3YRN1","error":"form_error__1WNvg"};